export enum Type {
  IDENTITY_CARD = 'IDENTITY_CARD',
}
